<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
      <el-text-field
        required
        :disabled="onlyView"
        label="Prašymo numeris"
        v-model="formData.request_number"
        :maxlength="40"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3">
      <!-- <el-text-field
        disabled
        label="Prašymo data"
        v-model="formData.request_date"
      /> -->
      <el-date-picker
        disabled
        label="Prašymo data"
        v-model="formData.request_date"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3">
      <el-text-field
        disabled
        label="Prašymo būsena"
        :value="getStatus"
      />
    </v-col>
    <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3" v-if="formData.pas_request_number">
      <el-text-field
        disabled
        label="PAS prašymo numeris"
        :value="formData.pas_request_number"
      />
    </v-col>
  </v-row>
</template>

<script>
  import Enums from '@/enums'

  export default {
    name: 'RequestDetails',
    components: {},
    props: {
      formData: [Array, Object],
      onlyView: Boolean
    },
    computed: {
      getStatus(){
        let statuses = this.$i18n.locale === 'lt' ? Enums.journalType.lt : Enums.journalType.en
        return statuses[this.formData.status]
      },
    }
  }
</script>

<style></style>
